/*
* 获取浮点数
* @param {Number, Number} 数字 保留几位小数
* @return {String} 
*/
Math.float = function (val, number){
  if (val === undefined) throw new Error('val is not defined')
  number = number || 2
  let value = this.round(parseFloat(val) * this.pow(10, number)) / this.pow(10, number)
  const floatArr = value.toString().split('.')
  const intPart = floatArr[0]
  const floatPart = floatArr[1] || ''
  let index = number - floatPart.length
  index = index > 0 ? index : 0
  value = intPart + '.' + floatPart + Array(index).fill(0).join('')
  return value
}


// WEBPACK FOOTER //
// ./src/prototype/Math.js